import { styled } from '@olxeu-jobs/ui';

export const Wrapper = styled('div', {
  position: 'relative',
  width: '120px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '64px',
});

export const Input = styled('input', { display: 'none' });

export const SelectButton = styled('button', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
  height: '100%',
  padding: 0,
  border: 0,
  backgroundColor: $theme.colors['background-global-inverse'],
  cursor: 'pointer',
  opacity: 0.9,
  aspectRatio: '1',
  ':hover': {
    opacity: 1,
  },
}));

export const ToolWrapper = styled('div', ({ $theme }) => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: $theme.space[16],
  zIndex: 1,
  [$theme.mediaQuery.hover]: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    opacity: 0,
    transition: `opacity ${$theme.animation.duration[150]}`,
    ':hover': {
      opacity: 1,
    },
    ':focus-within': {
      opacity: 1,
    },
  },
}));

export const ToolButton = styled('button', ({ $theme }) => ({
  display: 'flex',
  backgroundColor: $theme.colors['background-global-primary'],
  padding: $theme.space[6],
  border: 0,
  borderRadius: '100%',
  aspectRatio: '1/1',
  cursor: 'pointer',
}));

export const Image = styled('img', {
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});
